import { defineAction } from '~/prix'
import residenceMockAction from './residenceMock.action.json' with { type: 'json' }
import { z } from 'zod'

const residenceMockDefinition = defineAction({
  ...residenceMockAction,

  input: z.object({
    count: z.number().default(30000),
    seed: z.number().optional(),
    force: z.boolean().optional(),
  }),
  output: z.object({}),
})

export default residenceMockDefinition
